import { Component, OnInit, EventEmitter, Output, Input, TemplateRef } from '@angular/core';
import { G_TagsTypeViewModel } from 'src/app/viewmodels/g-settings/G_TagsTypeViewModel';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import Swal from 'sweetalert2';
import { SaveTagTypeRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-tags-type-form',
  templateUrl: './tags-type-form.component.html',
  styleUrls: ['./tags-type-form.component.scss']
})
export class TagsTypeFormComponent implements OnInit {

  @Input() public vm: SaveTagTypeRequest;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  private submitted = false;
  public IsDublicate: boolean = false;
  modalRef: BsModalRef;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
  ) { }

  ngOnInit() {
    if (this.vm == undefined) {
      this.vm = new SaveTagTypeRequest();
    }
    if (this.modal_title == undefined) {
      this.modal_title = 'Tags Type';
    }
  }

  saveOrUpdate() {
    this._jq.showSpinner(true);
    this._uow.gSettingService
      .SaveTagTypeAsync(this.vm)
      .toPromise().then((res: any) => {
        this.submitted = true;
        this.bsmRef.hide();
        this.onSubmitted.emit(this.submitted);
        Swal.fire(
          'Created!',
          'Created/Updated! Successfully',
          'success'
        )
      })
      .catch((error) => {
        Swal.fire(
          'Failure!',
          error.error.message,
          'error'
        )
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(this.submitted);
      });
  }

  checkTagDublication(tagName){
    this._jq.showSpinner(true);
    this._uow.tagsTypeService.checkDublication(tagName).toPromise().then((res : any)=>{
      if (res === true) {
        this.IsDublicate = false;
      }else{
        this.IsDublicate = true;
      }
      this._jq.showSpinner(false);
    }).catch((error) => {
      console.log(`Promise rejected with ${JSON.stringify(error)}`);
      this.onSubmitted.emit(this.submitted);
      this._jq.showSpinner(false);
    });
  }

  openTagTypeModel(template: TemplateRef<any>) {
    this.openModal(template);
  }

  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._modalService.show(template);
    }
  }

  onTagTypeSubmitted(e) {
    if (e == true) {
      this.modalRef.hide();
      this.ngOnInit();
    }
  }

  closeModal() {
    this.bsmRef.hide();
    this.onSubmitted.emit(true); // Emit event to refresh list
  }
}
